(function () {
  function b64(o) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(o))));
  }
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  async function subscribeToList(listId, email, firstName) {
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    const body = new URLSearchParams();
    body.set("g", listId);
    body.set("email", email);
    if (firstName) body.set("first_name", firstName);
    body.set("hp", "");
    body.set("source", "custom-shopify-form");
    body.set("confirm_optin", "false");
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body,
    });
    return await res.json().catch(() => ({}));
  }

  async function identifyPOST(publicKey, email, firstName, propKey, propVal) {
    if (!publicKey || !email || !propKey) return false;
    const payload = {
      token: publicKey,
      properties: {
        $email: email,
        $first_name: firstName || "",
        [propKey]: propVal,
      },
    };
    try {
      const r = await fetch("https://a.klaviyo.com/api/identify", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: "data=" + encodeURIComponent(b64(payload)),
      });
      const t = (await r.text()).trim();
      return r.ok && (t === "1" || t === "");
    } catch (e) {
      return false;
    }
  }

  function identifyGET(publicKey, email, firstName, propKey, propVal) {
    return new Promise((resolve) => {
      if (!publicKey || !email || !propKey) {
        resolve(false);
        return;
      }
      const payload = {
        token: publicKey,
        properties: {
          $email: email,
          $first_name: firstName || "",
          [propKey]: propVal,
          _ts: Date.now(),
        },
      };
      const img = new Image();
      const url =
        "https://a.klaviyo.com/api/identify?data=" +
        encodeURIComponent(b64(payload));
      let done = false;
      const finish = (ok) => {
        if (!done) {
          done = true;
          resolve(ok);
        }
      };
      img.onload = () => finish(true);
      img.onerror = () => finish(false);
      setTimeout(() => finish(true), 400);
      img.src = url;
    });
  }

  document.querySelectorAll(".klaviyo-subscribe").forEach((root) => {
    const LIST_ID = (root.dataset.klList || "").trim();
    const PUBLICKEY = (root.dataset.klPubkey || "").trim();
    const PROP_KEY = (root.dataset.klProp || "").trim();
    const RAW_VAL = root.dataset.klPropValue || "true";
    const PROP_VAL = /^(true|false)$/i.test(RAW_VAL)
      ? /^true$/i.test(RAW_VAL)
      : /^-?\d+(\.\d+)?$/.test(RAW_VAL)
      ? Number(RAW_VAL)
      : RAW_VAL;

    const form = root.querySelector(".klv-form");
    if (!form) return;
    const email = form.querySelector('input[name="email"]');
    const first = form.querySelector('input[name="first_name"]');
    const consent = form.querySelector(".klv-consent-input");
    const btn = form.querySelector(".klv-btn");
    const status = form.querySelector(".klv-status");
    const wrap =
      root.querySelector(".promo-form-wrapper") ||
      form.closest(".news__form-wrapper");
    const thanks =
      root.querySelector(".promo-form-thanks") ||
      root.querySelector(".news-form__message--success");

    const okMail = (v) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
    const setBtn = (v) => {
      if (btn) btn.disabled = !v;
    };
    const valid = () => okMail(email?.value) && (!consent || consent.checked);
    const upd = () => setBtn(valid());
    email?.addEventListener("input", upd);
    consent?.addEventListener("change", upd);
    upd();

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (!valid()) return;
      setBtn(false);
      if (status) {
        status.style.display = "";
        status.textContent = "Sending…";
      }
      try {
        const sub = await subscribeToList(
          LIST_ID,
          email.value,
          first?.value || ""
        );
        if (!sub || !sub.success) {
          if (status) status.textContent = "Error subscribing";
          setBtn(true);
          return;
        }

        if (PROP_KEY) {
          await sleep(600);
          let ok = await identifyPOST(
            PUBLICKEY,
            email.value,
            first?.value || "",
            PROP_KEY,
            PROP_VAL
          );
          if (!ok) {
            await sleep(1000);
            ok = await identifyPOST(
              PUBLICKEY,
              email.value,
              first?.value || "",
              PROP_KEY,
              PROP_VAL
            );
          }
          if (!ok) {
            await identifyGET(
              PUBLICKEY,
              email.value,
              first?.value || "",
              PROP_KEY,
              PROP_VAL
            );
          }
        }

        if (wrap) wrap.style.display = "none";
        if (thanks) {
          thanks.style.display = "";
          thanks.focus && thanks.focus();
        } else if (status) {
          status.textContent = "Subscribed successfully";
        }
      } catch (err) {
        if (status) status.textContent = "Network error";
        setBtn(true);
      }
    });
  });
})();

(function () {
  const popup   = document.querySelector(".klaviyo-subscribe.form-popup");
  const overlay = document.querySelector(".form-popup-overlay");
  const closeBtn = popup?.querySelector(".form-popup-close");

  const SEEN_KEY = "promo_popup_seen_session";

  let userOpened = false;

  function openPopup() {
    if (!popup || !overlay) return;
    if (popup.classList.contains("is-active")) return;

    popup.hidden = false;
    overlay.hidden = false;
    popup.classList.add("is-active");
    overlay.classList.add("is-active");


    try { sessionStorage.setItem(SEEN_KEY, "1"); } catch(e) {}
    userOpened = true;
  }

  function closePopup() {
    if (!popup || !overlay) return;
    popup.classList.remove("is-active");
    overlay.classList.remove("is-active");
    popup.hidden = true;
    overlay.hidden = true;
  }

  document.querySelectorAll(".top-bar__code a").forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      openPopup();
    });
  });
  document.querySelectorAll(".promo-slider__button").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openPopup();
    });
  });

  closeBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    closePopup();
  });
  overlay?.addEventListener("click", (e) => {
    e.preventDefault();
    closePopup();
  });

  window.addEventListener("load", () => {
    let seenSession = false;
    try { seenSession = sessionStorage.getItem(SEEN_KEY) === "1"; } catch(e) {}

    if (seenSession) return; 

    setTimeout(() => {
      if (!userOpened) openPopup();
    }, 180000); 
  });
})();

(function () {
  let pushed = false;

function pushSuccess(form) {
  if (pushed) return;
  pushed = true;

  var email = form.querySelector('input[name="email"]')?.value?.trim() || '';
  var name  = form.querySelector('input[name="first_name"]')?.value?.trim() || '';
  if (!email) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'nl_success', email, name });

  gtag('event', 'conversion', { send_to: 'AW-11001149638/hQKNCMOGxrsbEMbx4P0o' });
  fbq('track', 'Lead', { em: email, fn: name });
}

  function waitForSuccess(root, form) {
    var thanks = root.querySelector('.promo-form-thanks, .news-form__message--success');
    var status = root.querySelector('.klv-status');
    var wrap   = root.querySelector('.promo-form-wrapper') || form.closest('.news__form-wrapper');

    function isSuccess() {
      var thanksShown = thanks && getComputedStyle(thanks).display !== 'none';
      var wrapHidden  = wrap && getComputedStyle(wrap).display === 'none';
      var statusOk    = status && /subscribed successfully/i.test(status.textContent || '');
      return thanksShown || wrapHidden || statusOk;
    }

    if (isSuccess()) { pushSuccess(form); return; }

    var mo = new MutationObserver(function () {
      if (isSuccess()) {
        try { mo.disconnect(); } catch(e) {}
        pushSuccess(form);
      }
    });

    mo.observe(root, { attributes: true, childList: true, subtree: true, characterData: true });

    setTimeout(function () {
      if (isSuccess()) {
        try { mo.disconnect(); } catch(e) {}
        pushSuccess(form);
      }
    }, 6000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.klaviyo-subscribe').forEach(function (root) {
      var form = root.querySelector('.klv-form');
      if (!form) return;

      form.addEventListener('submit', function () {
        waitForSuccess(root, form);
      });
    });
  });
})();

